import { useState } from 'react';

const faqItems = [
  {
    q: '虫虫动漫的漫画全集资源真的完全免费吗？',
    a: '是的！虫虫动漫向所有用户承诺：平台上所有的漫画全集资源均完全免费在线阅读，无需注册登录，无隐藏收费，真正做到漫画完整版免费看。我们通过合理的运营模式维持平台运转，不会向读者收取任何费用。',
  },
  {
    q: '什么是下拉式阅读？和普通翻页阅读有什么不同？',
    a: '下拉式阅读是虫虫动漫独创的漫画浏览方式——整个章节或全卷漫画在同一页面内连续展示，您只需像刷社交媒体一样向下滑动即可流畅阅读，无需反复点击翻页按钮等待加载。这种方式让漫画完整版阅读体验更加沉浸，真正实现"一次性看完全卷完结漫画"。',
  },
  {
    q: '手机和平板上的阅读体验怎么样？',
    a: '虫虫动漫针对移动端做了全面优化。无论是手机还是平板电脑，浏览器直接打开即可获得原生应用般的流畅体验。页面自适应屏幕尺寸，字体和画面清晰易读，下拉式漫画阅读在移动端尤其舒适，横滑竖拉随心切换，随时随地畅享全集漫画完整版。',
  },
  {
    q: '平台上的漫画更新频率如何？',
    a: '虫虫动漫拥有专业的漫画大全内容运营团队，每天都会更新最新话漫画资源。热门连载漫画保持与首发平台同步更新的节奏，同时我们持续收录经典完结漫画全卷资源，确保漫画全集库不断丰富。建议每天来虫虫动漫看看，不错过任何精彩更新。',
  },
];

export default function SectionFaq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于漫画全集在线阅读的常见疑问解答
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <i
                  className={`ri-${openIdx === idx ? 'subtract' : 'add'}-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}